export function isUserLogged() {
    const token = localStorage.getItem('auth-token')
    return token && token !== null
}

export function logOut() {
    localStorage.removeItem('auth-token')
}
